package com.exura.components.icons

import androidx.compose.runtime.Composable
import com.exura.ui.Dimens
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier

@Composable
fun InlineIcon(
    modifier: Modifier = Modifier,
    isPrefix: Boolean = true,
    icon: @Composable () -> Unit,
    content: @Composable () -> Unit,
) {
    Row(
        modifier = Modifier.then(modifier),
        horizontalArrangement = Arrangement.spacedBy(Dimens.iconTextRelGapSizeDefault),
        verticalAlignment = Alignment.CenterVertically,
    ) {
        if (isPrefix) {
            icon()
        }

        content()

        if (!isPrefix) {
            icon()
        }
    }
}
